export { default as PrimerCambioFormulario } from './PrimerCambioFormulario';



// WEBPACK FOOTER //
// ./src/paginas/Login/paginas/PrimerCambioDeContraseña/componentes/index.ts